import React from "react";
import PropTypes from "prop-types";
import { OrderedMap } from "immutable";
import { List as AntList } from "antd";
import { FinancialDetailRecord } from "records";

const ListItem = AntList.Item;
const ListItemMeta = AntList.Item.Meta;

const AUTO_COMPUTED_RATIOS = new OrderedMap({
    financial_year: {
        label: "Year Ended",
        key: "financial_year",
        dataIndex: "financial_year"
    },
    ratio_debt_equity: {
        label: "Debt Equity",
        key: "ratio_debt_equity",
        dataIndex: "ratio_debt_equity"
    },
    ratio_tol_by_tnw: {
        label: "TOL/TNW",
        key: "ratio_tol_by_tnw",
        dataIndex: "ratio_tol_by_tnw"
    },
    ratio_current_ratio: {
        label: "Current Ratio",
        key: "ratio_current_ratio",
        dataIndex: "ratio_current_ratio"
    },
    ratio_net_working_capital: {
        label: "Net Working Capital",
        key: "ratio_net_working_capital",
        dataIndex: "ratio_net_working_capital"
    },
    ratio_ebitda: {
        label: "EBITDA",
        key: "ratio_ebitda",
        dataIndex: "ratio_ebitda"
    },
    ratio_ebitda_by_net_sales: {
        label: "EBITDA/Net Sales(%)",
        key: "ratio_ebitda_by_net_sales",
        dataIndex: "ratio_ebitda_by_net_sales"
    },
    ratio_creditor_turnover_days: {
        label: "Credit T/O days",
        key: "ratio_creditor_turnover_days",
        dataIndex: "ratio_creditor_turnover_days"
    },
    ratio_debtor_turnover_days: {
        label: "Debtor T/O days",
        key: "ratio_debtor_turnover_days",
        dataIndex: "ratio_debtor_turnover_days"
    }
});

const DSCR_CALCULATION = new OrderedMap({
    pnl_pat: {
        label: "Net Profit",
        key: "pnl_pat",
        dataIndex: "pnl_pat"
    },
    pnl_expense_depreciation: {
        label: "Depreciation",
        key: "pnl_expense_depreciation",
        dataIndex: "pnl_expense_depreciation"
    },
    pnl_finance_cost_interest_paid_numerator: {
        label: "Total Interest",
        key: "pnl_finance_cost_interest_paid_numerator",
        dataIndex: "pnl_finance_cost_interest_paid"
    },
    // ratio_dscr_numerator: {
    //     label: "Numerator",
    //     key: "ratio_dscr_numerator",
    //     dataIndex: "ratio_dscr_numerator"
    // },
    bs_liabilities_lt1yr_tl_emi_payable: {
        label: "Tl Emi Payable",
        key: "bs_liabilities_lt1yr_tl_emi_payable",
        dataIndex: "bs_liabilities_lt1yr_tl_emi_payable"
    },
    pnl_finance_cost_interest_paid_denominator: {
        label: "Total Interest",
        key: "pnl_finance_cost_interest_paid_denominator",
        dataIndex: "pnl_finance_cost_interest_paid"
    },
    // ratio_dscr_denominator: {
    //     label: "Denominator",
    //     key: "ratio_dscr_denominator",
    //     dataIndex: "ratio_dscr_denominator"
    // },
    ratio_dscr: {
        label: "DSCR",
        key: "ratio_dscr",
        dataIndex: "ratio_dscr"
    },
    ratio_interest_coverage_ratio: {
        label: "Interest Coverage Ratio",
        key: "ratio_interest_coverage_ratio",
        dataIndex: "ratio_interest_coverage_ratio"
    }
});

const listCols = name => {
    if (name === "ratios") {
        return AUTO_COMPUTED_RATIOS;
    }
    if (name === "dscr") {
        return DSCR_CALCULATION;
    }
};

const AutoComputedRatiosList = props => (
    <AntList
        size={props.size}
        className={"tabulated-list"}
        itemLayout={"horizontal"}
        style={{ padding: 0 }}
        dataSource={listCols(props.name)
            .filter((_, k) => k !== "financial_year")
            .toList()
            .toArray()}
        header={
            <ListItem key={listCols(props.name).first().label}>
                <ListItemMeta title={listCols(props.name).first().label} />
                <div className={"d-flex"}>
                    <div
                        style={{
                            width: "100px",
                            textAlign: "right"
                        }}
                    >
                        {props.f1 && props.f1["financial_year"].name}
                    </div>
                    <div
                        style={{
                            width: "100px",
                            textAlign: "right"
                        }}
                    >
                        {props.f2 && props.f2["financial_year"].name}
                    </div>
                </div>
            </ListItem>
        }
        renderItem={item => (
            <ListItem key={item.label}>
                <ListItemMeta title={item.label} />
                <div className={"d-flex"}>
                    <div
                        style={{
                            width: "100px",
                            textAlign: "right"
                        }}
                    >
                        {props.f1 &&
                            +props.f1[item.dataIndex] > 0 ?  Number(props.f1[item.dataIndex]).toFixed(2) : "--"}
                    </div>
                    <div
                        style={{
                            width: "100px",
                            textAlign: "right"
                        }}
                    >
                        {props.f2 && +props.f2[item.dataIndex] > 0 ?
                            Number(props.f2[item.dataIndex]).toFixed(2) : "--"}
                    </div>
                </div>
            </ListItem>
        )}
    >
        {props.name === "dscr" ? (
            <ListItem>
                <ListItemMeta title={"Average DSCR"} />
                <div>
                    {props.f1 && props.f2
                        ? FinancialDetailRecord.average_dscr(props.f1, props.f2)
                        : "--"}
                </div>
            </ListItem>
        ) : null}
    </AntList>
);

AutoComputedRatiosList.propTypes = {
    f1: PropTypes.object,
    f2: PropTypes.object,
    name: PropTypes.string,
    size: PropTypes.string
};

AutoComputedRatiosList.defaultProps = {
    size: "default"
};

export default AutoComputedRatiosList;
